<template>
  <div>
    <menubar :permission="permission"/>
    <div class="container">

      <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">アーカイブ済み対訳ファイル</p>
      </div>

      <div class="archived-files-head">
        <Link :href="route('translated_bilingual_files.index')" class="btn btn-translated-file">
          対訳ファイルポストエディット
        </Link>
        <Link :href="route('file_translate.index')" class="btn btn-purple">
          ファイル翻訳
        </Link>
      </div>

      <table class="component_table bilingual-file-table" cellpadding="5">
        <thead>
          <tr>
            <th class="th--file-name">ファイル</th>
            <th class="th--status">状態</th>
            <th class="th--team-name">チーム</th>
            <th class="th--user-name">ユーザ</th>
            <th class="th--language-pair">言語ペア</th>
            <th class="th--aimodel-name">AIモデル</th>
            <th class="th--glossary-name">用語集</th>
            <th class="th--date">更新日</th>
            <th class="th--dl-icon">DL</th>
            <th class="th--checkbox">選択</th>
          </tr>
        </thead>

        <tbody>
        
          <tr v-for="bilingualFile in translatedBilingualFiles" v-bind:class="[bilingualFile.status == 'PE' ? 'pe' : 'ai']">
            <td class="td--file-name"> 
              <input class="form-control" style="max-width: 100%; display: inline-block" v-show="bilingualFile.showNameInput" type="text" :value="bilingualFile.name" />
              <span v-if="! bilingualFile.showNameInput"> {{ bilingualFile.name }} </span>
              <div class="mt-3" style="text-align: right;">
                <button v-show="bilingualFile.showNameInput" class="btn btn-red" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeFileName($event, bilingualFile.id)" >
                  更新
                </button>
                <button class="btn btn-purple" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeFileInputElement($event, bilingualFile.id)">
                  <span v-show="!bilingualFile.showNameInput">変更</span>
                  <span v-show="bilingualFile.showNameInput">戻す</span>
                </button>
              </div>
            </td>
            <!-- [TODO] ハードコーディング気味なので解消する -->
            <td>
              <div v-if="bilingualFile.status=='PE' && bilingualFile.is_editing == 0"> 編集可 </div> 
              <div v-else-if="bilingualFile.status=='PE' && bilingualFile.is_editing == 1"> 編集中 </div> 
              <div v-else-if="bilingualFile.status=='AI'"> 翻訳中 </div> 
            </td>
            <td> {{ bilingualFile.team.name }}</td>
            <td>{{ bilingualFile.user.name }}
              <div v-if="bilingualFile.user.deleted_at != null" >(削除済み)</div>
            </td>

            <td> {{bilingualFile.src_language_code}} → {{bilingualFile.trg_language_code}} </td>
            <td class="td--aimodel-name"> {{ bilingualFile.aimodel.name }}</td>
            <td class="td--glossary-name">
              <div v-if="bilingualFile.glossary !== null"> {{ bilingualFile.glossary.name }} </div>
              <div v-else> 選択なし </div>
            </td>
            <td> {{ showLocalDate(bilingualFile.updated_at, "-") }}</td>
            <td class="td--dl-icon" >
              <a :href="route('translated_bilingual_files.download', {id:bilingualFile.id})">
                <img src="/img/12_download.svg" class="btn--download" />
              </a>
            </td>
            <td class="td--checkbox">
              <input type="checkbox" :id="bilingualFile.id" :value="bilingualFile.id" v-model="selectedFiles"/>
            </td>            
          </tr>
        </tbody>
      </table>

      <div class="translated-files-foot">
        <button class="btn btn-purple" @click="restoreFiles">PEに戻す</button>
        <button class="btn btn-red" @click="deleteFiles">削除</button>
      </div>

    </div>
    <footerComponent />

  </div>
</template>

<script>
import { computed, defineComponent } from "vue"
import { Link } from '@inertiajs/inertia-vue3';
import modal from "@/Pages/Components/modal.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from "@/Pages/Components/showLocalDate.js";

export default defineComponent({
  components: { 
    menubar,
    modal,
    footerComponent,
    Link,
  },
  props: {
    translatedBilingualFiles: Object,
    permission:String,
  },
  data() {
    return {
      selectedFiles: [],
      items: [
        {id: 1, file: "the taro", status: "AI", user: "太郎", update: "2022/03/10", langage: "英→日", model: "movie", word: "xxxxxxxxx", download_modal: false, return_modal: false, delete_modal: false},
        {id: 2, file: "the jiro", status: "AI", user: "次郎", update:"2022/03/10", langage:"英→日", model: "movie", word: "xxxxxxxxx", download_modal: false, return_modal: false, delete_modal: false},
        {id: 3, file: "the saburo", status: "AI", user: "三郎", update:"2022/03/10", langage:"英→日", model: "movie", word: "xxxxxxxxx", download_modal: false, return_modal: false, delete_modal: false},
      ],

      index_return: [], //戻るのチェックボックスのindexを格納
      index_delete: [], //削除のチェックボックスのindexを格納
    };
  },
  methods: {
    showLocalDate: function (date, separator) {
      return showLocalDate.showLocalDate(date, separator);
    },
    changeFileName: function( $event, id ){
      const newFileName = $event.srcElement.parentNode.parentNode.getElementsByTagName('input')[0].value;
      if ( newFileName === '' ){
        alert('対訳ファイル名を空白にすることはできません。');
        return;
      }

      const file = this.getFileById(id);
      file.name = newFileName;

      this.$inertia.put( this.route('translated_bilingual_files.update', file.id), file,
      {
        onSuccess:()=>{
          file.showNameInput = false;
          alert( '対訳ファイル名を変更しました。');
        },
        onError:(e)=>{
          alert(e.error_message);

        }
      });
    },
    changeFileInputElement( $event, id ){
      let file = this.getFileById(id);
      file.showNameInput = !file.showNameInput;

    },
    getFileById(id) {
      return this.translatedBilingualFiles.filter( (a)=>{return a.id == id;})[0];
    },
    // 戻るのチェエクボックスにチェックが入っていたときモーダル実行
    checkreturnModal: function () {
        if (this.index_return.length != 0) {
            this.$refs.childreturnModal.openModal();
        }
    },
    returnModal: function () {
        // 戻るモーダルで「はい」を押したときの処理をここに記述する
        this.$refs.childreturnModal.closeModal();
    },
    // 削除のチェエクボックスにチェックが入っていたときモーダル実行
    checkdeleteModal: function () {
        if (this.index_delete.length != 0) {
            this.$refs.childdeleteModal.openModal();
        }
    },
    deleteModal: function () {
        // 削除モーダルで「はい」を押したときの処理をここに記述する
        this.$refs.childdeleteModal.closeModal();
    },
    openfileModal: function ( index ) {
        // 翻訳ファイルオープンモーダルで「はい」を押したときの処理をここに記述する
        this.$refs.childfileModal[index].closeModal();
    },
    downloadModal: function ( index ) {
        // ダウンロードモーダルで「はい」を押したときの処理をここに記述する
        this.$refs.childdownloadModal[index].closeModal();
    },

    restoreFiles() {
      if (this.selectedFiles.length == 0) {
        alert("選択列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (!confirm("選択したファイルをポストエディット可能にします。よろしいですか？")) {
        return;
      }

      this.$inertia.patch(
        route("translated_bilingual_files.restore", this.selectedFiles.join(',')),
        {},
        {onSuccess: () => {
            alert("選択された対訳ファイルをポストエディット可能に戻しました");
        },
        onError:(e)=>{
          alert(e.error_message);
        }}
      );
    },
    deleteFiles() {
      if (this.selectedFiles.length == 0) {
        alert("削除列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (!confirm("この操作はやり直せません")) {
        return;
      }
      this.$inertia.delete(
        route("translated_bilingual_files.archivedDestroy", this.selectedFiles.join(',')),
        {onSuccess: () => {
            alert("選択された対訳ファイルを削除しました");
            this.selectedFiles = []
        },
        onError:(e)=>{
          alert(e.error_message);
        },
        only: []}
      );
    },
  },
  beforeMount() {
    this.translatedBilingualFiles.forEach((f)=>{
        f.showNameInput = false;
    });
  }
});
</script>

<style lang="scss" scoped>
.container {
  min-height: 80vh;
}
//=[ページの見出し]==========================================================//
#title {
  margin: 3rem 0;
  img {
    width: 3rem;
    height: 3rem;
  }
  p {color: #333333;}
}
//==========================================================================//

//=[テーブル上部の要素]======================================================//
.archived-files-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  .btn-translated-file {
    color: #763FD0;
    border-color: #763FD0;
    border-radius: 100vh;
  }
}
//==========================================================================//

//=[テーブル本体]============================================================//
.bilingual-file-table {
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: center;
  thead {
    border-top: 2px;
    height: 3rem;
  }
  tbody {
    border-top: 0;
    tr.ai > td {
      background: #e4d8f5;
    }
    td {
      padding: 10px;
    }
  }
}
// Table ヘッダの幅に関するスタイル
.th--file-name{width: 20%}
.th--aimodel-name, .th--glossary-name{width: auto;}
.th--team-name, .th--user-name, .th--date{width: 8rem;}
.th--language-pair{width: 6rem;}
.th--status{width: 5rem;}
.th--dl-icon, .th--checkbox{width: 4rem;}

// Table セルに関するスタイル
.td--file-name, .td--aimodel-name, .td--glossary-name{
  text-align: left;
  padding: 0 0 0 1rem;
}
.td--dl-icon, .td--checkbox{
  text-align: center;
  vertical-align: middle;
}
.btn--download {width: 20px;}
//==========================================================================//

//=[テーブル下部の要素]======================================================//
.translated-files-foot {
  text-align: end;
  margin: 1rem 0;
  button {
    margin: 0 0 0 1rem;
  }
  .switchAuthority {
    text-align: start;
  }
  .buttonArchiveDelete {
    text-align: end;
  }
}
//==========================================================================//
</style>